var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTooltipTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 13.001,
    viewBox: "0 0 20 13.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_238",
    "data-name": "Rechteck 238",
    width: 20,
    height: 13.001,
    transform: "translate(0 -0.001)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1242",
    "data-name": "Gruppe 1242",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1241",
    "data-name": "Gruppe 1241",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1014",
    "data-name": "Pfad 1014",
    d: "M.64,0,7.525,10.849a3.123,3.123,0,0,0,3.994.984,2.791,2.791,0,0,0,1.1-.984L19.5,0",
    fill: "#172135"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1015",
    "data-name": "Pfad 1015",
    d: "M20,0,13.4,11.114a3.817,3.817,0,0,1-1.467,1.4A4.032,4.032,0,0,1,10.007,13a3.946,3.946,0,0,1-3.4-1.886L0,0H2.239C2.339.162,8.2,10.03,8.3,10.192a1.88,1.88,0,0,0,.536.58,1.97,1.97,0,0,0,.643.3,2.017,2.017,0,0,0,1.482-.176,1.9,1.9,0,0,0,.733-.7L17.763,0Z",
    fill: "#0cf"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipTriangle);
export default __webpack_public_path__ + "static/media/tooltip-triangle.03db580b.svg";
export { ForwardRef as ReactComponent };